import React from 'react'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import checkPermission from '../../../Components/Hooks/PermissionHook';

function TableDuplicateButton({allowedPermission, onClick}) {
  const selectRoutePath = createSelector(state => state.MenuData, state => ({
    brandPath: state.brandPath,
    marketPath: state.marketPath,
  }));
  const { brandPath, marketPath } = useSelector(selectRoutePath);
  
  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), allowedPermission)) {
    return (
      <button className="btn border-0 px-3 btn btn-ghost-primary" onClick={onClick}>
        <i className="mdi mdi-card-multiple-outline align-bottom me-1"></i>
        Duplicate
      </button>
    )
  } else {
    return null;
  }
}

export default TableDuplicateButton
